import { baseApi } from './baseApi'
import { IRouletteOption } from '../../types/roulette'

export const rouletteApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRouletteOptions: builder.query<IRouletteOption[], void>({
      query: () => '/roulette',
      providesTags: ['Roulette'],
    }),
    getRouletteOptionById: builder.query<IRouletteOption, string>({
      query: (id) => `/roulette/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'Roulette', id }],
    }),
    createRouletteOption: builder.mutation<
      IRouletteOption,
      Omit<IRouletteOption, '_id'>
    >({
      query: (params) => ({
        url: '/roulette',
        method: 'POST',
        body: params,
        headers: { 'Content-Type': 'application/json' },
      }),
      invalidatesTags: ['Roulette'],
    }),
    deleteRouletteOption: builder.mutation<void, string>({
      query: (id) => ({
        url: `/roulette/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Roulette'],
    }),
    updateRouletteOption: builder.mutation<
      IRouletteOption,
      { params: Partial<IRouletteOption>; id: string }
    >({
      query: ({ params, id }) => ({
        url: `/roulette/${id}`,
        method: 'PUT',
        body: params,
        headers: { 'Content-Type': 'application/json' },
      }),
      invalidatesTags: ['Roulette'],
    }),
    spinRoulette: builder.mutation<{ prize: string }, void>({
      query: () => '/roulette/spin',
    }),
  }),
})

export const {
  useGetRouletteOptionsQuery,
  useGetRouletteOptionByIdQuery,
  useCreateRouletteOptionMutation,
  useDeleteRouletteOptionMutation,
  useUpdateRouletteOptionMutation,
  useSpinRouletteMutation,
} = rouletteApi
